import request from './request';

/**
 * Monitor Runtime API — 实时监控服务层
 */
export const monitorAPI = {
  /**
   * 获取行程时间线
   * GET /monitor/timeline/:tripId
   */
  getTimeline: (tripId) => request.get(`/monitor/timeline/${tripId}`),

  /**
   * 检测异常
   * GET /monitor/anomalies/:tripId
   */
  detectAnomalies: (tripId) => request.get(`/monitor/anomalies/${tripId}`),

  /**
   * 触发重规划
   * POST /monitor/replan/:tripId
   */
  replan: (tripId) => request.post(`/monitor/replan/${tripId}`),

  /**
   * 获取环境数据
   * GET /monitor/environment/:tripId
   */
  getEnvironment: (tripId) => request.get(`/monitor/environment/${tripId}`),

  /**
   * 前端兜底 Mock
   */
  mockGetTimeline: () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          tripId: 'trip_sh_001',
          tripTitle: '上海三日旅行 · Day 2',
          status: 'running',
          activeAnomalies: 1,
          events: [
            { time: '09:00', title: '酒店出发', status: 'done' },
            { time: '09:30', title: '外滩观景台', status: 'done' },
            { time: '11:00', title: '新天地漫步', status: 'done' },
            { time: '12:30', title: '午餐 · 本帮菜', status: 'done' },
            { time: '14:00', title: '豫园', status: 'alert', alertReason: '景点临时闭馆' },
            { time: '16:00', title: '南京路购物', status: 'upcoming' },
            { time: '18:00', title: '星空日料 · 外滩', status: 'upcoming' },
          ],
        });
      }, 600);
    });
  },

  mockReplan: () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          tripId: 'trip_sh_001',
          replanId: 'rp_' + Date.now(),
          status: 'completed',
          newPlan: [
            { time: '14:00', title: '上海博物馆 (室内)', status: 'new' },
            { time: '16:00', title: '南京路购物', status: 'unchanged' },
            { time: '18:00', title: '星空日料 · 外滩', status: 'unchanged' },
          ],
          recoveryTime: '12 分钟',
          confidence: 0.91,
          summary: '路线已恢复。所有风险 LOW。较原方案增加 0.3h，室内替代方案已确认可用。',
        });
      }, 1500);
    });
  },

  mockGetEnvironment: () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          weather: { condition: '大雨', temperature: '18-22°C', alert: '暴雨黄色预警' },
          location: { current: '新天地', distanceToNext: '1.2km', etaNext: '15 min' },
          traffic: { overall: '缓行', metro: '正常运行', roadCondition: '部分路段积水' },
        });
      }, 400);
    });
  },
};

export default monitorAPI;
